import { Component, Inject } from "@angular/core";
import { FormControl } from "@angular/forms";
import { DateAdapter } from "@angular/material/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'date-filter-modal',
    templateUrl: './date-filter-modal.component.html',
    styleUrls: ['./date-filter-modal.component.scss'],
    standalone: false
})
export class DateFilterModalComponent {
    startDateCtrl: FormControl = new FormControl();
    endDateCtrl: FormControl =  new FormControl();
    maxDate = new Date();

    constructor(@Inject(MAT_DIALOG_DATA) private dialogData:any,
    private dialogRef: MatDialogRef<DateFilterModalComponent>,
    private dateAdapter: DateAdapter<Date>){
        this.dateAdapter.setLocale('en-GB');
    }

    close(val: string){
        if(val === 'ok'){
            if(this.startDateCtrl.value && this.endDateCtrl.value){
                const obj = {
                    action: 'ok',
                    startDate: this.startDateCtrl.value,
                    endDate: this.endDateCtrl.value
                };
                this.dialogRef.close(obj);
            } else {
                return;
            }
        } else {
            const obj = {
                action: 'cancel',
                startDate: null,
                endDate: null
            };
            this.dialogRef.close(obj);
        }
    }
}